import type { Signal } from '@angular/core';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { LengthCounterService } from './length-counter.service';
import type { LengthCounterState } from './length-counter.types';

@Component({
  selector: 'rt-wysiwyg-length-counter',
  template: `
    @if (counterState()?.isEnabled) {
      <span text-small>
        {{ counterState()?.value + '/' + counterState()?.limit }}
      </span>
    }
  `,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '[style.display]': 'counterState()?.isEnabled ? "inline" : "none"',
  },
})
export class LengthCounterComponent {
  private readonly svc = inject(LengthCounterService);

  public counterState: Signal<LengthCounterState | undefined>;

  constructor() {
    this.counterState = toSignal(this.svc.state);
  }
}
